var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 66,
    viewBox: "0 0 95 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 23.6321C77.9 19.6321 81.9 15.3321 88.7 11.2321C90.6 10.1321 91.8 8.13207 91.8 6.03207C91.8 1.73207 87.4 -1.26793 83.4 0.532073C71.8 5.63207 52.5 18.3321 52.5 44.6321C52.5 56.4321 62 65.9321 73.8 65.9321C85.6 65.9321 95 56.4321 95 44.7321C95 33.6321 86.5 24.6321 75.7 23.6321Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 23.6321C25.3 19.6321 29.3 15.3321 36.1 11.2321C38 10.1321 39.2 8.13207 39.2 6.03207C39.2 1.73207 34.8 -1.26793 30.8 0.532073C19.3 5.63207 0 18.3321 0 44.6321C0 56.4321 9.5 65.9321 21.2 65.9321C32.9 65.9321 42.5 56.4321 42.5 44.6321C42.5 33.6321 34 24.6321 23.1 23.6321Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quote-icon.8c3acbcd25a3e7c6ac2801750ce90391.svg";
export { ForwardRef as ReactComponent };